import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Select from 'react-select';
import {
  getCustomerReports,
  sendReportToCustomer,
  setReport,
  setOrg,
  returnToMain,
  getBansForOrg,
  resetState,
} from './BusinessReportBlockSlice';
import TextInput from '../../Shared/TextInput/TextInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {ReportFilterType, screenStep} from './BusinessReportEnums';
import he from 'date-fns/locale/he';
import DatePicker from 'react-datepicker';
import {CompletedWithError, CompletedWithSuccess} from './CompletionScreens';
import {getReportParams, report} from '../../../middleware/report';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import {gaEvent, gtag4} from '../../../utilities/analytics/tracking';
import '../CellcomAbroadLobbyBlock/DatePicker/datePicker.scss';

const BusinessReportMain = (props) => {
  const [filterValuesData, setFilterValuesData] = useState([]);
  const [mailAddress, setMail] = useState('');
  const [mailError, setMailError] = useState(null);
  const [selectedBan, setBan] = useState(null);
  const colourStyles = {
    option: (styles, {data, isDisabled, isFocused, isSelected}) => {
      return {
        ...styles,
        backgroundColor: isSelected ? '#f2f2f2' : null,
        color: '#000',
      };
    },
  };

  useEffect(() => {
    const fetchReports = async () => {
      await props.getCustomerReports(props.iContent.reportFolderLink?.expandedValue?.contentLink?.id);
    };
    fetchReports();
    if (props.lobbyOrg) {
      props.setOrg(props.lobbyOrg);
    } else if (props.selectedOrg != null) {
      props.getBansForOrg(props.selectedOrg);
    }
    gtag4({
      event: 'ReportGenerator_OrderReportPage',
      action: 'OrderReportPage',
    });

    return () => {
      props.resetState();
    };
  }, []);

  useEffect(() => {
    if (props.selectedOrg) {
      props.getBansForOrg(props.selectedOrg);
    }
  }, [props.selectedOrg]);

  useEffect(() => {
    if (props.screen) {
      switch (props.screen) {
        case screenStep.SUCCESS:
          reportSuccess();
          break;
        case screenStep.FAILURE:
          reportFail();
          break;
      }
    }
  }, [props.screen]);

  useEffect(() => {
    if (props.selectedReport) {
      const reportChosen = props.reports.find((r) => r.reportId == props.selectedReport);
      const filterValuesArr = reportChosen.filters.map((f) => {
        const filtInitVal = f.filterType == ReportFilterType.BOOLEAN ? false : '';
        return {
          key: f.filterId,
          value: filtInitVal,
          id: f.filterId,
          name: f.filterText,
          type: f.filterType,
          error: null,
        };
      });
      setFilterValuesData(filterValuesArr);
      onSelectReport();
    }
  }, [props.reports, props.selectedReport]);

  const mailValidation = () => {
    const regMail =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regMail.test(String(mailAddress).toLowerCase());
  };

  const getMonth = (month) => {
    switch (month) {
      case 0:
        return 'ינואר';
      case 1:
        return 'פברואר';
      case 2:
        return 'מרץ';
      case 3:
        return 'אפריל';
      case 4:
        return 'מאי';
      case 5:
        return 'יוני';
      case 6:
        return 'יולי';
      case 7:
        return 'אוגוסט';
      case 8:
        return 'ספטמבר';
      case 9:
        return 'אוקטובר';
      case 10:
        return 'נובמבר';
      case 11:
        return 'דצמבר';
    }
  };

  const is_israeli_id_number = (id) => {
    return (
      /\d{9}/.test(id) &&
      !id.match(/^0*$/) &&
      Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) %
        10 ===
        0
    );
  };

  const dwh_reportChosen = () => {
    let org = props.orgList.find((o) => o.organizationId == props.selectedOrg);
    let rep = props.reports.find((rep) => rep.reportId == props.selectedReport);
    let reportParams = getReportParams();
    reportParams.channel = 'WebsiteBusiness';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'ContactPersonReports';
    reportParams.status = 'Ongoing';
    reportParams.customerName =
      props.authentication.loginData.userDetails.firstName + ' ' + props.authentication.loginData.userDetails.lastName;
    reportParams.param1 = props.selectedOrg;
    reportParams.param3 = props.selectedOrg;
    reportParams.param4 = props.authentication.loginData.userDetails.firstName + ' ' + props.authentication.loginData.userDetails.lastName;
    reportParams.param5 = org.organizationName;
    reportParams.param10 = rep.reportName;
    reportParams.actionType = 'ReportName';
    reportParams.messageText = 'ReportName';
    report(reportParams);
    reportParams.actionType = 'ReportDescription';
    reportParams.messageText = 'ReportDescription';
    reportParams.param2 = rep.reportDesc;
    report(reportParams);
  };

  const dwh_reportFilter = (field) => {
    let org = props.orgList.find((o) => o.organizationId == props.selectedOrg);
    let rep = props.reports.find((rep) => rep.reportId == props.selectedReport);
    let reportParams = getReportParams();
    reportParams.channel = 'WebsiteBusiness';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'ContactPersonReports';
    reportParams.status = 'Ongoing';
    reportParams.customerName =
      props.authentication.loginData.userDetails.firstName + ' ' + props.authentication.loginData.userDetails.lastName;
    reportParams.param1 = props.selectedOrg;
    reportParams.param2 = rep.reportDesc;
    reportParams.param3 = props.selectedOrg;
    reportParams.param4 = props.authentication.loginData.userDetails.firstName + ' ' + props.authentication.loginData.userDetails.lastName;
    reportParams.param5 = org.organizationName;
    reportParams.param10 = rep.reportName;
    reportParams.actionType = field;
    reportParams.messageText = field;
    report(reportParams);
  };

  const onSelectReport = () => {
    let rep = props.reports.find((rep) => rep.reportId == props.selectedReport);
    dwh_reportChosen();
    rep.filters.forEach((f) => dwh_reportFilter(f.filterType));
  };

  const reportSuccess = () => {
    let org = props.orgList.find((o) => o.organizationId == props.selectedOrg);
    let rep = props.reports.find((rep) => rep.reportId == props.selectedReport);
    let reportParams = getReportParams();
    reportParams.channel = 'WebsiteBusiness';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'ContactPersonReports';
    reportParams.status = 'Completed';
    reportParams.customerName =
      props.authentication.loginData.userDetails.firstName + ' ' + props.authentication.loginData.userDetails.lastName;
    reportParams.param1 = props.selectedOrg;
    reportParams.param2 = rep.reportDesc;
    reportParams.param3 = props.selectedOrg;
    reportParams.param4 = props.authentication.loginData.userDetails.firstName + ' ' + props.authentication.loginData.userDetails.lastName;
    reportParams.param5 = org.organizationName;
    reportParams.param10 = rep.reportName;
    reportParams.actionType = 'SuccessScreen';
    reportParams.messageText = 'SuccessScreen';
    report(reportParams);

    gtag4({
      event: 'ReportGenerator_SuccessPage',
      action: 'SuccessPage',
    });
  };

  const reportFail = () => {
    let org = props.orgList.find((o) => o.organizationId == props.selectedOrg);
    let rep = props.reports.find((rep) => rep.reportId == props.selectedReport);
    let reportParams = getReportParams();
    reportParams.channel = 'WebsiteBusiness';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'ContactPersonReports';
    reportParams.status = 'Error';
    reportParams.customerName =
      props.authentication.loginData.userDetails.firstName + ' ' + props.authentication.loginData.userDetails.lastName;
    reportParams.param1 = props.selectedOrg;
    reportParams.param2 = rep.reportDesc;
    reportParams.param3 = props.selectedOrg;
    reportParams.param4 = props.authentication.loginData.userDetails.firstName + ' ' + props.authentication.loginData.userDetails.lastName;
    reportParams.param5 = org.organizationName;
    reportParams.param10 = rep.reportName;
    reportParams.actionType = 'ErrorScreen';
    reportParams.messageText = 'ErrorScreen';
    report(reportParams);

    gtag4({
      event: 'ReportGenerator_ErroePage',
      action: 'ErroePage',
      error: props.businessReportState.error?.errorDesc,
    });
  };
  const getDatesForSelectedBan = () => {
    const selectedBanFromList = props.orgBanList?.find((b) => b.banId == selectedBan);
    const cycle = selectedBanFromList?.billDate;
    let date = new Date();
    const dates = [];
    date.setMonth(date.getMonth() + 1);
    for (let i = 0; i < 12; i++) {
      date.setMonth(date.getMonth() - 1);
      dates.push({
        value: `${date.getFullYear()}${(date.getMonth() + 1).toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })}${cycle}`,
        label: `${getMonth(date.getMonth())} ${date.getFullYear()}`,
        key: `${date.getFullYear()}${date.getMonth() + 1}${cycle}`,
      });
    }
    return dates;
  };

  const validateFilter = (filterVal, f) => {
    let errorTick = filterVal === '' ? 'אנא מלא שדה זה' : null;
    if (errorTick == null) {
      switch (f.type) {
        case ReportFilterType.INTEGER:
          {
            const intReg = /^[-+]?\d*$/;
            errorTick = intReg.test(filterVal) ? null : 'אנא הזן מספר שלם תקין';
          }
          break;
        case ReportFilterType.DECIMAL:
          {
            const decReg = /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/;
            errorTick = decReg.test(filterVal) ? null : 'אנא הזן מספר עשרוני תקין';
          }
          break;
        case ReportFilterType.ID:
          errorTick = is_israeli_id_number(filterVal) ? null : 'אנא הזן ת.ז. תקינה';
          break;
        case ReportFilterType.PHONE:
          console.log('validate phone with value ', filterVal);
          const phonePattern = /^0((5\d{1})|([2-4,8-9]\d{0,1}))-?\d{7}$/;
          console.log('phone pattern test result ', phonePattern.test(filterVal));
          errorTick = phonePattern.test(filterVal) || filterVal.length >= 9 ? null : 'אנא הזן מספר מנוי תקין';
          break;
      }
    }
    const filterState = [...filterValuesData];
    const filtIndex = filterState.findIndex((filt) => filt.id == f.id);
    if (f.type == ReportFilterType.DATE) {
      const dates = getDatesForSelectedBan();
      filterState[filtIndex].text = dates.find((d) => d.value == filterVal).label;
    }
    filterState[filtIndex].value = filterVal;
    filterState[filtIndex].error = errorTick;
    setFilterValuesData(filterState);

    console.log('Validation of ', f, 'resulted in ', errorTick);
  };

  const changeFilterValue = (filterVal, f) => {
    const filterState = [...filterValuesData];
    const filtIndex = filterState.findIndex((filt) => filt.id == f.id);
    if (f.type == ReportFilterType.DATE) {
      const dates = getDatesForSelectedBan();
      filterState[filtIndex].text = dates.find((d) => d.value == filterVal).label;
    }
    filterState[filtIndex].error = null;
    filterState[filtIndex].value = filterVal;
    setFilterValuesData(filterState);
  };

  const checkForErrors =
    filterValuesData?.find(
      (filt) => filt.type != ReportFilterType.BOOLEAN && (filt.error != null || filt.value == '' || filt.value == null),
    ) != null ||
    !props.selectedOrg ||
    !props.selectedReport ||
    !selectedBan ||
    !mailValidation();

  const generateTextField = (f) => {
    return (
      <div className='reportFilter adjustWidth' key={f.id}>
        <div className='textFilterHeading'>{f.name}</div>
        <TextInput
          placeholder={f.name}
          name={f.id}
          value={filterValuesData?.find((filt) => filt.id == f.id)?.value}
          type='text'
          onChange={(e) => {
            e.persist();
            validateFilter(e.target.value, f);
          }}
          error={filterValuesData?.find((filt) => filt.id == f.id)?.error}
        />
      </div>
    );
  };
  const generateNumberField = (f) => {
    return (
      <div className='reportFilter adjustWidth' key={f.id}>
        <div className='textFilterHeading'>{f.name}</div>
        <TextInput
          placeholder={f.name}
          name={f.id}
          type={'number'}
          maxLength={f.type == ReportFilterType.PHONE ? 10 : undefined}
          value={filterValuesData?.find((filt) => filt.id == f.id)?.value}
          inputMode={'numeric'}
          pattern='[0-9]*'
          onChange={(e) => {
            e.persist();
            changeFilterValue(e.target.value, f);
          }}
          onBlur={(e) => {
            e.persist();
            validateFilter(e.target.value, f);
          }}
          error={filterValuesData?.find((filt) => filt.id == f.id)?.error}
        />
      </div>
    );
  };
  const generateBooleanField = (f) => {
    return (
      <div className='reportFilter adjustWidth toggleSection' key={f.id}>
        <div className='booleanHeading'>{f.name}</div>
        <div className='togglersContainer'>
          <span
            className={`boolToggler ${filterValuesData?.find((filt) => filt.id == f.id)?.value ? ' toggled' : ''}`}
            onClick={() => {
              validateFilter(true, f);
            }}>
            כן
          </span>
          <span
            className={`boolToggler ${!filterValuesData?.find((filt) => filt.id == f.id)?.value ? ' toggled' : ''}`}
            onClick={() => {
              validateFilter(false, f);
            }}>
            לא
          </span>
        </div>
      </div>
    );
  };
  const generateDateField = (f, zInd) => {
    const dateOptions = getDatesForSelectedBan();
    return (
      <div className='reportFilter adjustWidth' key={f.id} style={{zIndex: zInd}}>
        <div className='textFilterHeading'>{f.name}</div>
        <Select
          placeholder={f.name}
          onChange={(e) => {
            validateFilter(e.value, f);
          }}
          styles={colourStyles}
          error={filterValuesData?.find((filt) => filt.id == f.id)?.error}
          classNamePrefix='adjustWidth'
          isRtl={true}
          options={dateOptions}
          value={
            dateOptions?.find((d) => d.value == filterValuesData?.find((filt) => filt.id == f.id)?.value)
              ? getSelectedDateOption(f.id)
              : null
          }
          required
        />
      </div>
    );
  };

  const submitReports = () => {
    gtag4({
      event: 'ReportGenerator_OrderReportClick',
      button: 'שלח',
      action: 'OrderReportClick',
      title: props.orgList.find((o) => o.organizationId == props.selectedOrg).organizationName,
      content: selectedBan,
    });

    const submitRep = async (sendData) => {
      await props.sendReportToCustomer(sendData);
    };

    if (!checkForErrors) {
      const sendData = {
        blockId: props.selectedReport,
        orgId: props.selectedOrg,
        mail: mailAddress,
        reportName: props.reports.find((r) => r.reportId == props.selectedReport).reportName,
        filters: filterValuesData.map((f) => {
          return {key: f.id, filterId: f.id, filterType: f.type, filterText: f.value};
        }),
      };
      sendData.filters.push({key: 'ban', filterId: 'ban', filterType: ReportFilterType.BAN, filterText: selectedBan});
      submitRep(sendData);
    }
  };

  const renderFilters = () => {
    if (props.selectedReport) {
      let zInd = 70;
      const filterComponents = filterValuesData?.map((f) => {
        zInd -= 1;
        let retF = null;
        switch (f.type) {
          case ReportFilterType.INTEGER:
          case ReportFilterType.DECIMAL:
          case ReportFilterType.PHONE:
            retF = generateNumberField(f);
            break;
          case ReportFilterType.DATE:
            retF = generateDateField(f, zInd);
            break;
          case ReportFilterType.BOOLEAN:
            retF = generateBooleanField(f);
            break;
          default:
            retF = generateTextField(f);
            break;
        }
        return retF;
      });
      return filterComponents;
    }
  };

  const getSelectedReportOption = () => {
    let rep = props.reports.find((r) => r.reportId == props.selectedReport);
    return {value: rep.reportId, label: rep.reportName, key: rep.reportId};
  };
  const getSelectedOrgOption = () => {
    let org = props.orgList.find((o) => o.organizationId == props.selectedOrg);
    return {value: org.organizationId, label: org.organizationName, key: org.organizationId};
  };
  const getSelectedBanOption = (filterId) => {
    return {value: selectedBan, label: selectedBan, key: selectedBan};
  };
  const getSelectedDateOption = (filterId) => {
    let dateSelected = filterValuesData.find((f) => f.id == filterId);
    let dateFilter = dateSelected.value;
    let textFilter = dateSelected.text;
    return {value: dateFilter, label: textFilter, key: dateFilter};
  };
  const getReportOptions = () => {
    if (props.reports == null || props.reports == [] || props.orgBanList == null || props.orgBanList == []) return null;
    const allowedIndexes = selectedBan ? props.orgBanList.find((b) => b.banId == selectedBan)?.allowedReports : [];
    const reportsToShow = props.reports?.map((rep) => {
      if (
        rep.mabatIndex == '' ||
        (parseInt(rep.mabatIndex) != NaN &&
          parseInt(rep.mabatIndex) != undefined &&
          parseInt(rep.mabatIndex) != null &&
          parseInt(rep.mabatIndex) <= 0) ||
        allowedIndexes?.includes(rep.mabatIndex)
      )
        return {value: rep.reportId, label: rep.reportName, key: rep.reportId};
    });
    if (reportsToShow == null || reportsToShow == undefined) return null;
    return reportsToShow.filter((r) => r != undefined && r != null);
  };

  const renderCreationScreen = () => {
    return (
      <>
        <div className='headingContainer'>
          <h2>הזמנת דו"ח</h2>
        </div>
        {props.orgList != [] && !props.lobbyOrg && (
          <div className='orgs ReportSelecterContainer'>
            <div className='selecterHeading'>בחירת ארגון</div>
            <div className='selecterSubHeading'>הקלידו את שם הארגון אותו תרצו לבחור</div>

            <Select
              placeholder='שם הארגון'
              classNamePrefix='adjustWidth'
              isRtl={true}
              styles={colourStyles}
              options={props.orgList.map((org) => {
                return {value: org.organizationId, label: org.organizationName, key: org.organizationId};
              })}
              value={props.selectedOrg ? getSelectedOrgOption() : null}
              required
              onChange={(e) => {
                props.setOrg(e.value);
              }}
            />
          </div>
        )}

        <div className='bans ReportSelecterContainer'>
          <div className='selecterHeading'>בחירת לקוח</div>
          <div className='selecterSubHeading'>הקלידו את מספר הלקוח עבורו תרצו להפיק את הדו"ח</div>
          <Select
            placeholder={'מספר לקוח'}
            onChange={(e) => {
              setBan(e.value);
            }}
            styles={colourStyles}
            classNamePrefix='adjustWidth'
            isRtl={true}
            isDisabled={props.selectedOrg == null}
            options={props.orgBanList?.map((ban) => {
              let banId = ban.banId;
              return {value: banId, label: banId, key: banId};
            })}
            value={props.orgBanList?.find((b) => b.banId == selectedBan) ? getSelectedBanOption() : null}
            required
          />
        </div>

        {props.reports != [] && (
          <div className='reports ReportSelecterContainer'>
            <div className='selecterHeading'>מציאת סוג הדו"ח</div>
            <div className='selecterSubHeading'>הקלידו את סוג הדו"ח אותו תרצו להפיק</div>
            <Select
              placeholder='שם הדו"ח'
              classNamePrefix='adjustWidth'
              isRtl={true}
              styles={colourStyles}
              options={getReportOptions()}
              isDisabled={props.selectedOrg == null || selectedBan == null}
              value={props.selectedReport ? getSelectedReportOption() : null}
              required
              onChange={(e) => {
                props.setReport(e.value);
              }}
            />
          </div>
        )}

        <div className='filters'>{renderFilters()}</div>
        <div className='filters'>
          <div className='mailAddress reportFilter adjustWidth'>
            <div className='textFilterHeading'>הזינו כתובת מייל</div>
            <TextInput
              placeholder={'כתובת מייל'}
              name={'mailAddress'}
              value={mailAddress}
              type='email'
              onChange={(e) => {
                e.persist();
                setMail(e.target.value);
              }}
              onBlur={() => {
                setMailError(mailValidation() ? null : 'אנא הזן כתובת מייל תקינה');
              }}
              onFocus={() => {
                setMailError(null);
              }}
              error={mailError}
            />
          </div>
        </div>

        <div className='submitDiv'>
          <div className='submitTipper'>הדו״ח ישלח אליכם במהלך השעות הקרובות</div>
          <BtnSubmit isBusiness={true} onclick={submitReports} disabled={checkForErrors ? 'disabled' : ''} text={'שלח'} />{' '}
        </div>
      </>
    );
  };
  let renderedElement = renderCreationScreen();
  switch (props.screen) {
    case screenStep.SUCCESS:
      renderedElement = <CompletedWithSuccess props={props} />;
      break;
    case screenStep.FAILURE:
      renderedElement = <CompletedWithError props={props} />;
      break;
  }
  return <div className='businessReportMain'>{renderedElement}</div>;
};

const mapStateToProps = (state) => {
  return {
    businessReportState: state.businessReport,
    orgList: state.businessReport.orgList,
    reports: state.businessReport.reportList,
    selectedReport: state.businessReport.selectedReport,
    selectedOrg: state.businessReport.selectedOrg,
    errors: state.businessReport.error,
    filterListValues: state.businessReport.filterListValues,
    lobbyOrg: state.portalsBlock.selectedHetPay,
    screen: state.businessReport.screenStep,
    orgBanList: state.businessReport.orgBanList,
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  getCustomerReports,
  sendReportToCustomer,
  setReport,
  setOrg,
  returnToMain,
  getBansForOrg,
  resetState,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessReportMain);
